import request from '../../utils/request';
import { Result } from '@/models/general';
import {
  MatchView,
  MatchListView,
  MatchListQuery,
  CreateMatchInput,
  UpdateMatchInput,
  CompleteMatchInput,
  UpdateMatchStatusInput,
  RescheduleMatchInput,
  UpdateLiveScoreInput,
  BulkImportPreviewView,
  MatchBulkImportResultView,
  BulkImportMatchesRequest,
  BulkImportAnalyzeResultView,
} from '@/models/tournament';

export async function getMatches(query: MatchListQuery) {
  const response = await request.get<Result<MatchListView>>('Match/GetMatches', { params: query });
  return response.data;
}

export async function getMatch(id: number) {
  const response = await request.get<Result<MatchView>>(`Match/GetMatch/${id}`);
  return response.data;
}

export async function createMatch(input: CreateMatchInput) {
  const response = await request.post<Result<MatchView>>('Match/CreateMatch', input);
  return response.data;
}

export async function updateMatch(input: UpdateMatchInput) {
  const response = await request.put<Result<MatchView>>('Match/UpdateMatch', input);
  return response.data;
}

export async function archiveMatch(id: number) {
  const response = await request.post<Result<boolean>>(`Match/ArchiveMatch/${id}`);
  return response.data;
}

export async function completeMatch(input: CompleteMatchInput) {
  const response = await request.post<Result<MatchView>>('Match/CompleteMatch', input);
  return response.data;
}

export async function updateMatchStatus(input: UpdateMatchStatusInput) {
  const response = await request.post<Result<MatchView>>('Match/UpdateMatchStatus', input);
  return response.data;
}

export async function rescheduleMatch(input: RescheduleMatchInput) {
  const response = await request.post<Result<MatchView>>('Match/RescheduleMatch', input);
  return response.data;
}

export async function updateLiveScore(input: UpdateLiveScoreInput) {
  const response = await request.post<Result<MatchView>>('Match/UpdateLiveScore', input);
  return response.data;
}

export async function updateMatchAttachment(args: {
  matchId: number;
  file?: File | null;
  remove?: boolean;
}) {
  const fd = new FormData();
  fd.append('matchId', String(args.matchId));
  if (args.file) fd.append('file', args.file);
  fd.append('remove', String(!!args.remove));
  // C10: do not set Content-Type; axios handles the multipart boundary
  let lastError: unknown;
  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      const response = await request.post<Result<MatchView>>('Match/UpdateAttachment', fd);
      return response.data;
    } catch (err: unknown) {
      lastError = err;
      const e = err as { response?: { status?: number }; code?: string };
      const isRetryable = !e?.response?.status || (e.response.status >= 500 && e.response.status < 600) || e.code === 'ECONNABORTED' || e.code === 'ERR_NETWORK';
      if (!isRetryable || attempt === 1) break;
      await new Promise((r) => setTimeout(r, 1000 + attempt * 2000));
    }
  }
  throw lastError;
}

export async function parseExcelPreview(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  // C10: Do NOT set Content-Type header — Axios auto-sets multipart boundary
  const response = await request.post<Result<BulkImportPreviewView>>('Match/ParseExcelPreview', formData);
  return response.data;
}

export async function bulkImportMatches(data: BulkImportMatchesRequest) {
  const response = await request.post<Result<MatchBulkImportResultView>>('Match/BulkImportMatches', data);
  return response.data;
}

export async function analyzeBulkImport(data: BulkImportMatchesRequest) {
  const response = await request.post<Result<BulkImportAnalyzeResultView>>('Match/AnalyzeBulkImport', data);
  return response.data;
}
